import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import MyTable from '../../utils/MyTable';

import IconButton from '@material-ui/core/IconButton';

import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import ListIcon from '@material-ui/icons/List';

import SyncIcon from '@material-ui/icons/Sync';
import LinkIcon from '@material-ui/icons/Link';

import Checkbox from '@material-ui/core/Checkbox';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import { InstituitionAPI } from '../../../API/instituition';

import { headerSearch, tabs, toogleButton, unoTheme } from '../../../assets/styles/unoTheme';
import { MyTab, MyTabs } from '../../utils/MyTabs';
import UnoButton from '../../utils/UnoButton';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../actions';
import { DistributorsAPI } from '../../../API/distributors';
import { FundsManagersAdministratorsAPI } from '../../../API/funds_managers_administrators';
import LinkInstituitionModal from '../../modals/LinkInstituitionModal';
import { applyMaskCnpj, justNumbers } from '../../utils/utils';
import { checkUserIsRole, roles } from '../../utils/user';

//Abas da tela
const TAB_INSTITUITIONS = 0;
const TAB_DISTRIBUTORS = 1;
const TAB_MANAGERS = 2;
const TAB_ADMINISTRATORS = 3;

//Entidades vinculáveis a uma instituição (abas 2 e 3)
const MANAGERS = 'managers';
const ADMINISTRATORS = 'administrators';

const LINK_FILTER_ALL = 'todos';
//Os dois eixos independentes do cadastro, e os dois problemas que valem virar fila de trabalho:
//sem instituição vinculada, a R9 (art. 21) não sabe o segmento Bacen; sem nome no arquivo da
//ANBIMA, a R8 (art. 20) não acha o volume gerido. Não há filtro por "sem S1/S2" porque isso não
//é problema: com a política de só cadastrar S1 e S2, a entidade vinculada e sem segmentação
//está corretamente cadastrada
const LINK_FILTER_WITHOUT = 'semVinculo';
const LINK_FILTER_NO_ANBIMA = 'semAnbima';

const ITEMS_PAGE_ENTITIES = 15;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },
    tabs: tabs,
    toogleButton: toogleButton,
    statusChip: {
        display: 'inline-block',
        padding: '2px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        textTransform: 'uppercase',
        background: unoTheme.warningColor,
        color: '#5A4B00',
    },

    //Segmentacao cadastrada: e o que habilita o gestor ou o administrador na R9
    bacenChip: {
        display: 'inline-block',
        padding: '2px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        background: 'rgba(8, 194, 27, 0.12)',
        color: unoTheme.greenMoney,
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        '& > *': {
            marginLeft: theme.spacing(2)
        },
        '&:first-child': {
            marginLeft: theme.spacing(0)
        }
    },
}));

export default function InstituitionsScreen() {

    const classes = useStyles();
    const rightContent = useSelector(state => state.rightContent)
    const currentUser = useSelector(state => state.currentUser)

    //Instituitions
    const [listInstituitions, setListInstituitions] = useState([]);
    const [itemsPageInstituitions, setItemsPageInstituitions] = useState(15);
    const [pageInstituitions, setPageInstituitions] = useState(1);

    //Distributors
    const [listDistributors, setListDistributors] = useState([]);

    //Gestores e administradores de fundos
    const [listManagers, setListManagers] = useState([]);
    const [listAdministrators, setListAdministrators] = useState([]);
    const [pageManagers, setPageManagers] = useState(1);
    const [pageAdministrators, setPageAdministrators] = useState(1);

    //Instituições ativas oferecidas no modal de vínculo
    const [activeInstituitions, setActiveInstituitions] = useState([]);

    //Filtro rápido das abas de gestores/administradores
    const [linkFilter, setLinkFilter] = useState(LINK_FILTER_ALL);

    //Competência do arquivo da ANBIMA conferido na listagem. Nula quando não há arquivo, e é isso
    //que faz a coluna mostrar '-' em vez de acusar o cadastro inteiro de incompleto
    const [anbimaCompetence, setAnbimaCompetence] = useState(null);

    //Linha clicada; enquanto não for null o modal de vínculo fica aberto
    const [selectedEntityRow, setSelectedEntityRow] = useState(null);

    //Disparo manual da rotina de atualização em andamento
    const [processing, setProcessing] = useState(false);

    //Seleção múltipla indexada por id: o índice da linha não serve como chave,
    //porque a lista é filtrada e paginada
    const [checkedEntities, setCheckedEntities] = useState({});
    const [bulkLinkOpen, setBulkLinkOpen] = useState(false);

    const [tabValue, setTabValue] = useState(0);

    const dispatch = useDispatch();

    const handleChangeTabValue = (event, newValue) => {
        setTabValue(newValue);
    };

    async function getAllInstituitions() {

        const response = await InstituitionAPI.listAllInstituitions();
        if (response.success) {
            console.log('INSTITUITIONS: ', JSON.stringify(response.body.rows));
            setListInstituitions(response.body.rows);
        } else {
            console.log("RESPONSE ERROR: ", response.error)
        }
    }

    async function updateStatusInstituition(instId, status) {

        const response = await InstituitionAPI.updateInstituition(instId, status);
        if (response.success) {
            //setListInstituitions(response.body.rows);
            console.log(response.body)
            callback();
        } else {
            console.log("RESPONSE ERROR: ", response.error)
        }

    }

    const callback = useCallback(() => {
        getAllInstituitions();
    }, [])

    const getAllDistributors = async () => {

        const response = await DistributorsAPI.getAll();
        console.log("response: ", response);
        if (response.success) {
            const { rows } = response.body;
            setListDistributors(rows);
        }

    }

    const getAllManagers = async () => {

        const response = await FundsManagersAdministratorsAPI.getAllManagers();
        if (response.success) {
            const { rows, anbima_competence } = response.body;
            setListManagers(rows);
            setAnbimaCompetence(anbima_competence);
        } else {
            console.log("RESPONSE ERROR: ", response.body)
        }

    }

    const getAllAdministrators = async () => {

        const response = await FundsManagersAdministratorsAPI.getAllAdministrators();
        if (response.success) {
            const { rows, anbima_competence } = response.body;
            setListAdministrators(rows);
            setAnbimaCompetence(anbima_competence);
        } else {
            console.log("RESPONSE ERROR: ", response.body)
        }

    }

    const getActiveInstituitions = async () => {

        const response = await InstituitionAPI.listActivesInstituitions();
        if (response.success) {
            const { rows } = response.body;
            setActiveInstituitions(rows);
        } else {
            console.log("RESPONSE ERROR: ", response.body)
        }

    }

    const loadTabContent = (tab) => {

        if (tab === TAB_INSTITUITIONS) {
            getAllInstituitions();
        } else if (tab === TAB_DISTRIBUTORS) {
            getAllDistributors();
        } else if (tab === TAB_MANAGERS) {
            getAllManagers();
        } else if (tab === TAB_ADMINISTRATORS) {
            getAllAdministrators();
        }

    }

    useEffect(() => {

        loadTabContent(tabValue);

        //Obrigatório limpar: funds_managers e funds_administrators têm ids independentes que
        //começam ambos em 1, então uma seleção remanescente marcaria linhas erradas na outra aba
        setCheckedEntities({});

        //As instituições ativas só são necessárias no modal de vínculo das abas 2 e 3
        if ((tabValue === TAB_MANAGERS || tabValue === TAB_ADMINISTRATORS)
            && !activeInstituitions.length) {
            getActiveInstituitions();
        }

    }, [tabValue]);

    useEffect(() => {
        if (rightContent && rightContent.action) {
            dispatch(allActions.rightContentActions.setRightContent(null))
            loadTabContent(tabValue);
        }
    }, [rightContent])

    const [searchText, setSearchText] = useState("");

    const delayedChange = (text) => {
        setTimeout(() => {
            setSearchText(text)
        }, 800)
    }

    function changeSearch(e) {

        delayedChange(e.target.value.toUpperCase())
        clearTimeout(delayedChange);
    }

    //Guarda contra a deseleção do ToggleButtonGroup exclusive, que devolve null
    const handleLinkFilter = (event, newValue) => {
        if (newValue) {
            setLinkFilter(newValue);
        }
    };

    //Ao filtrar/buscar a paginação some; voltar para a primeira página evita
    //reexibir a lista completa numa página que não existe mais
    useEffect(() => {

        setPageManagers(1);
        setPageAdministrators(1);

    }, [linkFilter, searchText]);

    const isEntityTab = tabValue === TAB_MANAGERS || tabValue === TAB_ADMINISTRATORS;
    const hasEntityFilter = searchText !== '' || linkFilter !== LINK_FILTER_ALL;

    //Filtro de vínculo + busca por CNPJ (com ou sem máscara) ou por nome. A busca considera
    //também os nomes alternativos: é o que permite colar um nome vindo da outra base e
    //descobrir a qual registro ele pertence
    const filterEntities = (list) => {

        const searchNumbers = justNumbers(searchText);

        return list.filter(row =>
            (linkFilter === LINK_FILTER_ALL
                || (linkFilter === LINK_FILTER_WITHOUT && !row.instituition_id)
                || (linkFilter === LINK_FILTER_NO_ANBIMA && !row.anbima_name))
            && (searchText === ''
                || (row.name && row.name.toUpperCase().includes(searchText))
                || (row.other_names && row.other_names.some(
                    el => el && el.toUpperCase().includes(searchText)))
                || (searchNumbers !== '' && row.cnpj && row.cnpj.includes(searchNumbers))));
    }

    const filteredManagers = filterEntities(listManagers);
    const filteredAdministrators = filterEntities(listAdministrators);

    const selectedCount = Object.values(checkedEntities).filter(Boolean).length;

    const getSelectedIds = () => Object.entries(checkedEntities)
        .filter(([, checked]) => checked)
        .map(([id]) => parseInt(id));

    const toggleOneEntity = (id) => {
        setCheckedEntities((prev) => ({ ...prev, [id]: !prev[id] }));
    }

    //Marca/desmarca apenas as linhas renderizadas (a página atual, ou a lista
    //inteira quando há filtro ativo, que é quando a paginação some)
    const toggleAllVisibleEntities = (visibleRows, allSelected) => {
        setCheckedEntities((prev) => {
            const newChecked = { ...prev };
            visibleRows.forEach(row => { newChecked[row.id] = !allSelected; });
            return newChecked;
        });
    }

    async function doLinkInstituition(instituitionId) {

        const { id, entity } = selectedEntityRow;
        const isManager = entity === MANAGERS;

        const response = isManager ?
            await FundsManagersAdministratorsAPI.updateManagerInstituition(id, instituitionId)
            :
            await FundsManagersAdministratorsAPI.updateAdministratorInstituition(id, instituitionId);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: instituitionId ?
                    'Instituição vinculada com sucesso!'
                    : 'Instituição desvinculada com sucesso!'
            }))

            setSelectedEntityRow(null);
            isManager ? getAllManagers() : getAllAdministrators();

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao vincular a instituição: ' + (response.body ? response.body.message : '')
            }))

        }

    }

    //Aplica a mesma instituição (ou desvincula, com instituitionId nulo) a todos os selecionados
    async function doBulkLinkInstituition(instituitionId) {

        const ids = getSelectedIds();
        const isManager = tabValue === TAB_MANAGERS;

        const response = isManager ?
            await FundsManagersAdministratorsAPI.updateManagersInstituitionBatch(ids, instituitionId)
            :
            await FundsManagersAdministratorsAPI.updateAdministratorsInstituitionBatch(ids, instituitionId);

        if (response.success) {

            const { updated } = response.body;

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: instituitionId ?
                    `Instituição vinculada a ${updated} registro(s) com sucesso!`
                    : `Instituição desvinculada de ${updated} registro(s) com sucesso!`
            }))

            setBulkLinkOpen(false);
            setCheckedEntities({});
            loadTabContent(tabValue);

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao vincular a instituição em lote: '
                    + (response.body && response.body.message ? response.body.message : '')
            }))

        }

    }

    //Dispara manualmente a mesma rotina do job, que processa sempre o mês anterior
    async function doProcessEntities() {

        setProcessing(true);
        dispatch(allActions.fullLoadActions.setFullLoad({
            show: true,
            message: 'Atualizando gestores e administradores...'
        }))

        const response = await FundsManagersAdministratorsAPI.processFundsManagersAndAdministrators();

        dispatch(allActions.fullLoadActions.setFullLoad({ show: false }))
        setProcessing(false);

        if (response.success) {

            const { month, year, managers, administrators } = response.body;

            //A competência vai na mensagem porque o disparo é sempre no mês anterior: sem ela,
            //um resultado zerado (mês ainda sem cotas carregadas) pareceria falha do botão
            const competence = String(month).padStart(2, '0') + '/' + year;
            const total = managers.inserted + administrators.inserted;

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: total ? 'success' : 'warning',
                message: total ?
                    `Competência ${competence}: ${managers.inserted} gestor(es) e ${administrators.inserted} administrador(es) cadastrados.`
                    : `Competência ${competence}: nenhum gestor ou administrador novo encontrado.`
            }))

            loadTabContent(tabValue);

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao atualizar gestores e administradores: '
                    + (response.body && response.body.message ? response.body.message : '')
            }))

        }

    }

    //Uma única definição de tabela para gestores e administradores, que só diferem nos dados
    const renderEntityTable = (entity, list, page, setPage) => {

        //As linhas efetivamente renderizadas: com filtro ativo a paginação some e a lista vem
        //inteira. O select-all precisa exatamente do mesmo conjunto
        const visibleRows = !hasEntityFilter ? list.slice(
            (page * ITEMS_PAGE_ENTITIES) - ITEMS_PAGE_ENTITIES,
            ITEMS_PAGE_ENTITIES + (ITEMS_PAGE_ENTITIES * (page - 1))
        ) : list;

        const allVisibleSelected = visibleRows.length > 0
            && visibleRows.every(row => checkedEntities[row.id]);
        const someVisibleSelected = visibleRows.some(row => checkedEntities[row.id]);

        return <MyTable
            pagination={!hasEntityFilter && list.length > 0}
            itemspage={ITEMS_PAGE_ENTITIES}
            totalitems={list.length}
            currentPage={page}
            handlePage={(value) => setPage(page + value)}
            stickyHeader
            selectable="true"
            size="small">
            <colgroup>
                <col width="5%" />
                <col width="13%" />
                <col width="28%" />
                <col width="22%" />
                <col width="7%" />
                <col width="17%" />
                <col width="8%" />
            </colgroup>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.tableTh} align="center">
                        <Checkbox
                            checked={allVisibleSelected}
                            indeterminate={someVisibleSelected && !allVisibleSelected}
                            color="primary"
                            onChange={() => toggleAllVisibleEntities(visibleRows, allVisibleSelected)}
                            inputProps={{ 'aria-label': 'selecionar todos' }}
                        />
                    </TableCell>
                    <TableCell className={classes.tableTh} align="center">CNPJ</TableCell>
                    <TableCell className={classes.tableTh} align="left">Nome</TableCell>
                    <TableCell className={classes.tableTh} align="left">Instituição</TableCell>
                    <TableCell className={classes.tableTh} align="center">Bacen</TableCell>
                    <TableCell className={classes.tableTh} align="left">ANBIMA</TableCell>
                    <TableCell className={classes.tableTh} align="center">Nomes</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {visibleRows.map((row) => (

                    <TableRow key={entity + '-' + row.id}
                        onClick={() => setSelectedEntityRow({ ...row, entity: entity })}>

                        <TableCell align="center" className='noPaddingCell'>
                            <Checkbox
                                checked={checkedEntities[row.id] === true}
                                color="primary"
                                onClick={(e) => {
                                    //A linha inteira é clicável (abre o modal individual);
                                    //o clique no checkbox não pode disparar isso
                                    e.preventDefault()
                                    e.stopPropagation()
                                }}
                                onChange={() => toggleOneEntity(row.id)}
                                inputProps={{ 'aria-label': 'selecionar registro' }}
                            />
                        </TableCell>
                        <TableCell align="center">{applyMaskCnpj(row.cnpj)}</TableCell>
                        <TableCell align="left" component="th" scope="row">{row.name}</TableCell>
                        <TableCell align="left">
                            {
                                row.instituition_id ?
                                    row.instituition_description
                                    :
                                    <span className={classes.statusChip}>{'Sem vínculo'}</span>
                            }
                        </TableCell>
                        <TableCell align="center">
                            {
                                //A segmentação da instituição vinculada é o que a R9 lê.
                                //"Sem Bacen" distingue o vínculo feito pela metade do sem vínculo
                                row.instituition_status_bacen ?
                                    <span className={classes.bacenChip}>
                                        {row.instituition_status_bacen}
                                    </span>
                                    : (row.instituition_id ?
                                        <span className={classes.statusChip}>{'Sem Bacen'}</span>
                                        : '-')
                            }
                        </TableCell>
                        <TableCell align="left">
                            {
                                //O nome com que a entidade aparece no arquivo da ANBIMA. É essa
                                //grafia que precisa ser cadastrada como nome alternativo para a
                                //R8 achar o volume gerido — e errá-la não dá erro, só mantém a
                                //gestora sem ser avaliada
                                !anbimaCompetence ?
                                    '-'
                                    : (row.anbima_name ?
                                        <span className={row.anbima_ambiguous ?
                                            classes.statusChip : classes.bacenChip}>
                                            {row.anbima_name + (row.anbima_ambiguous ? ' (ambíguo)' : '')}
                                        </span>
                                        :
                                        <span className={classes.statusChip}>{'Sem ANBIMA'}</span>)
                            }
                        </TableCell>
                        <TableCell align="center">
                            {row.other_names && row.other_names.length ? row.other_names.length : '-'}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </MyTable>;
    };

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={classes.tabs}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}
                    >

                        <MyTab label={"Instituições"} value={0} />
                        <MyTab label={"Distribuidores"} value={1} />
                        <MyTab label={"Gestores"} value={2} />
                        <MyTab label={"Administradores"} value={3} />

                    </MyTabs>

                    {/* <div className={classes.bottomTabs}></div> */}
                </div>
                <div className={classes.rightHeader}>
                    <div className={classes.headerSearch}>

                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                            {
                                //Filtro rápido de vínculo: só nas abas de gestores e administradores
                                isEntityTab ?
                                    <ToggleButtonGroup
                                        className={classes.toogleButton}
                                        exclusive
                                        value={linkFilter}
                                        onChange={handleLinkFilter}>
                                        <ToggleButton value={LINK_FILTER_ALL} aria-label="Todos">
                                            {'Todos'}
                                        </ToggleButton>
                                        <ToggleButton value={LINK_FILTER_WITHOUT} aria-label="Sem vínculo">
                                            {'Sem vínculo'}
                                        </ToggleButton>
                                        {
                                            //Sem arquivo da ANBIMA o filtro selecionaria todo o
                                            //cadastro por um motivo que não é de cadastro
                                            anbimaCompetence ?
                                                <ToggleButton value={LINK_FILTER_NO_ANBIMA} aria-label="Sem ANBIMA">
                                                    {'Sem ANBIMA'}
                                                </ToggleButton>
                                                : null
                                        }
                                    </ToggleButtonGroup> : null
                            }

                            {
                                tabValue !== TAB_DISTRIBUTORS ?
                                    <TextField id="standard-basic"
                                        onChange={(event) => changeSearch(event)}
                                        className={classes.inputSearch}
                                        label="Buscar..."
                                        variant="outlined"
                                        size="small" /> : null
                            }

                            {
                                //Vínculo em lote: aparece assim que houver seleção nas abas de entidade
                                isEntityTab && selectedCount > 0 ?
                                    <UnoButton
                                        variant="contained"
                                        type='primary'
                                        onClick={() => setBulkLinkOpen(true)}
                                        startIcon={<LinkIcon />}>
                                        {`VINCULAR (${selectedCount})`}
                                    </UnoButton> : null
                            }

                            {
                                //Disparo manual da rotina: só nas abas de entidade e só para perfil administrativo.
                                //Some enquanto há seleção, para dar espaço ao botão de vínculo em lote
                                isEntityTab && selectedCount === 0
                                    && checkUserIsRole(currentUser, [roles.superadmin, roles.admin]) ?
                                    <UnoButton
                                        variant="contained"
                                        type='warning'
                                        disabled={processing}
                                        onClick={() => doProcessEntities()}
                                        startIcon={<SyncIcon />}>
                                        {processing ? "ATUALIZANDO..." : "ATUALIZAR"}
                                    </UnoButton> : null
                            }

                            {
                                tabValue === TAB_INSTITUITIONS ?
                                    <UnoButton
                                        variant="contained"
                                        type='primary'
                                        onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                            path: 'newInstituition',
                                        }))}
                                        startIcon={<AddIcon />}>
                                        {"NOVA INSTITUIÇÃO"}
                                    </UnoButton> : null
                            }

                            {
                                tabValue === TAB_DISTRIBUTORS ?
                                    <UnoButton
                                        variant="contained"
                                        type='primary'
                                        onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                            path: 'newDistributor',
                                        }))}
                                        startIcon={<AddIcon />}>
                                        {"NOVO DISTRIBUIDOR"}
                                    </UnoButton> : null
                            }

                        </div>

                    </div>
                </div>
            </div>


            <div class={'defaultScrollWithHeaderContent'}>


                {/* Instituitions */}
                {
                    tabValue === 0 &&
                    <MyTable
                        pagination={searchText == '' && listInstituitions && listInstituitions.length > 0}
                        itemspage={itemsPageInstituitions}
                        totalitems={listInstituitions ? listInstituitions.length : 0}
                        handlePage={(value) => setPageInstituitions(pageInstituitions + value)}
                        stickyHeader
                        selectable="true"
                        size="small">
                        <colgroup>
                            <col width="10%" />
                            <col width="50%" />
                            <col width="14%" />
                            <col width="13%" />
                            <col width="13%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableTh} align="center">Cod</TableCell>
                                <TableCell className={classes.tableTh} align="left">Descrição</TableCell>
                                <TableCell className={classes.tableTh} align="center">Bacen</TableCell>
                                <TableCell className={classes.tableTh} align="center">Status</TableCell>
                                <TableCell className={classes.tableTh} align="center">Fundos</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(searchText == '' ? listInstituitions.slice(
                                (pageInstituitions * itemsPageInstituitions) - (itemsPageInstituitions),
                                itemsPageInstituitions + (itemsPageInstituitions * (pageInstituitions - 1))
                            ) : listInstituitions).map((row) => (
                                <>
                                    {
                                        searchText == "" || (
                                            row.cod.includes(searchText)
                                            || row.description.includes(searchText)) ?
                                            <TableRow key={'instituition-' + row.id} onClick={
                                                () => dispatch(allActions.rightContentActions.setRightContent({
                                                    path: 'newInstituition',
                                                    update: true,
                                                    data: { ...row }
                                                }))
                                            }>
                                                <TableCell align="center">{row.cod}</TableCell>
                                                <TableCell align="left" component="th" scope="row">{row.description}</TableCell>
                                                <TableCell align="center">{row.status_bacen || '-'}</TableCell>
                                                <TableCell align="center">

                                                    {
                                                        row.cod != '000' ?
                                                            <IconButton className={classes.iconButton}
                                                                size={'small'}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    updateStatusInstituition(row.id, !row.active)
                                                                }} color="inherit">
                                                                {row.active ?
                                                                    <CheckCircleOutlineRoundedIcon className={classes.green} />
                                                                    :
                                                                    <HighlightOffRoundedIcon className={classes.red} />
                                                                }
                                                            </IconButton> : null
                                                    }


                                                </TableCell>
                                                <TableCell align="center">
                                                    <IconButton
                                                        size={'small'}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            dispatch(allActions.rightContentActions.setRightContent({
                                                                path: 'fundsFromInstituition',
                                                                data: { ...row }
                                                            }))
                                                        }}
                                                        color="inherit">
                                                        <ListIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow> : null
                                    }
                                </>
                            ))}
                        </TableBody>
                    </MyTable>
                }

                {
                    tabValue === 1 &&
                    <MyTable
                        selectable="true"
                        stickyHeader
                        size="small">
                        <colgroup>
                            <col width="10%" />
                            <col width="30%" />
                            <col width="60%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableTh} align="center">Id</TableCell>
                                <TableCell className={classes.tableTh} align="center">CNPJ</TableCell>
                                <TableCell className={classes.tableTh} align="left">Nome</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listDistributors.map((row) => (

                                <TableRow key={"distributor-" + row.id} onClick={
                                    () => dispatch(allActions.rightContentActions.setRightContent({
                                        path: 'newDistributor',
                                        update: true,
                                        data: { ...row }
                                    }))
                                }>
                                    <TableCell align="center">{row.id}</TableCell>
                                    <TableCell align="center">{row.cnpj}</TableCell>
                                    <TableCell align="left">{row.name}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </MyTable>
                }

                {/* Gestores */}
                {
                    tabValue === TAB_MANAGERS &&
                    renderEntityTable(MANAGERS, filteredManagers, pageManagers, setPageManagers)
                }

                {/* Administradores */}
                {
                    tabValue === TAB_ADMINISTRATORS &&
                    renderEntityTable(ADMINISTRATORS, filteredAdministrators, pageAdministrators, setPageAdministrators)
                }

            </div>

            <LinkInstituitionModal
                open={selectedEntityRow != null}
                title={selectedEntityRow && selectedEntityRow.entity === MANAGERS ?
                    'Vincular instituição ao gestor' : 'Vincular instituição ao administrador'}
                entityName={selectedEntityRow ? selectedEntityRow.name : ''}
                currentInstituitionId={selectedEntityRow ? selectedEntityRow.instituition_id : null}
                instituitions={activeInstituitions}
                entity={selectedEntityRow ? selectedEntityRow.entity : null}
                entityId={selectedEntityRow ? selectedEntityRow.id : null}
                canEditNames={checkUserIsRole(currentUser, [roles.superadmin, roles.admin])}
                handleClose={() => setSelectedEntityRow(null)}
                handleSelect={(instituitionId) => doLinkInstituition(instituitionId)}
                handleNamesChanged={() => selectedEntityRow && selectedEntityRow.entity === MANAGERS ?
                    getAllManagers() : getAllAdministrators()} />

            <LinkInstituitionModal
                open={bulkLinkOpen}
                title={'Vincular instituição em lote'}
                entityLabel={'Registros'}
                entityName={`${selectedCount} `
                    + (tabValue === TAB_MANAGERS ? 'gestor(es)' : 'administrador(es)')
                    + ' selecionado(s)'}
                allowUnlink
                currentInstituitionId={null}
                instituitions={activeInstituitions}
                handleClose={() => setBulkLinkOpen(false)}
                handleSelect={(instituitionId) => doBulkLinkInstituition(instituitionId)} />

        </div>
    );
}



